import React from 'react';

import { MEDIUM_OUTFIT } from '@/components/modular-grid/constants';
import ModularGridGameTile from '@/components/modular-grid/ModularGridGameTile';
import { GameClickProps, GameTileProps } from '@/components/modular-grid/types';

import styles from './GameTilesCarousel.module.scss';
import { JackpotBetWidgetPropTypes } from './JackpotBetWidget';

type Props = {
  games: GameTileProps[];
  speed: number;
  onGameTileClick: JackpotBetWidgetPropTypes['onGameTileClick'];
  onGameTileInfoClick: JackpotBetWidgetPropTypes['onGameTileInfoClick'];
};

export const GameTilesCarousel = ({
  games,
  speed,
  onGameTileClick,
  onGameTileInfoClick,
}: Props) => {
  const createClickHandler = (callback?: Function) => (
    game: GameClickProps,
    path?: string
  ) => {
    if (!callback) return;

    callback({
      game,
      gameMode: 'JP Bet Widget',
      gamePosition: 0,
      ...(path && { path }),
    });
  };

  return (
    <div className={styles.carouselContainer}>
      <div
        className={styles.carousel}
        style={{ animationDuration: games.length * speed + 's' }}
      >
        {games.map(game => (
          <ModularGridGameTile
            key={game.id}
            onClick={createClickHandler(onGameTileClick)}
            onInfoClick={createClickHandler(onGameTileInfoClick)}
            game={game}
            tileSize="small"
            outfit={MEDIUM_OUTFIT}
            isAnchor
            isLazy
            shouldShowSash={false}
          />
        ))}
      </div>

      {/* List is copied in order for the animation to flow properly */}
      <div
        className={styles.carousel}
        style={{ animationDuration: games.length * speed + 's' }}
      >
        {games.map(game => (
          <ModularGridGameTile
            key={game.id}
            onClick={createClickHandler(onGameTileClick)}
            onInfoClick={createClickHandler(onGameTileInfoClick)}
            tileSize="small"
            game={game}
            outfit={MEDIUM_OUTFIT}
            isAnchor
            isLazy
            shouldShowSash={false}
          />
        ))}
      </div>
    </div>
  );
};
